<template>
  <div class="screen-1">
    <div class="inner">
      <div class="top">
        <img src="@/assets/ppt/标语.png" />
      </div>
      <div class="bottom">
        <img class="img1" src="@/assets/ppt/双引号1.png" />
        <span>永辉超市作为国内零售领军企业，致力于为满足用户需求，提供安全、健康、高性价比的食品，永辉商品百科全书承载商品知识，沉淀商品文化，助力永辉商品经营，是每个永辉人的商品宝典。</span>
        <img class="img2" src="@/assets/ppt/双引号2.png" />
      </div>
    </div>
  </div>
</template>

<script>
import Screen from "./Screen";
export default {
  name: "Screen1",
  extends: Screen,
  data() {
    return {
      id: 1
    };
  }
};
</script>

<style lang="scss">
.screen-1 {
  .inner {
    z-index: 3;
  }

  .top {
    width: 592px;

    img {
      width: 100%;
    }
  }

  .bottom {
    width: 532px;

    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    padding: 50px 30px;
    margin-top: 64px;

    .img1 {
      width: 45px;
      margin-right: 55px;
      background: rgba(255, 255, 255, 1);
      opacity: 0.4;
      //   vertical-align: middle;
    }

    .img2 {
      width: 45px;
      margin-left: 235px;
      vertical-align: middle;
      background: rgba(255, 255, 255, 1);
      opacity: 0.4;
    }

    span {
      color: white;

      font-size: 20px;

      line-height: 50px;
    }
  }
}
</style>